import '../style.scss';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { CorporateAccountOpenProfileDetailsPages, useCorporateAccountOpenProfileDetailsPageTypeStore } from 'views/pages/accountOpenProfileDetails/corporateProfileDetails/hooks';
import { Caption } from 'views/mutual/caption';
import { CheckInput, MultiCheckInput } from 'views/templates/module/checkInput';
import { FormContentHeader, FormType } from 'views/templates/module/contentHeader';
import { useTransactionPurpose } from './hooks';
import { InputTemplate } from 'views/templates/module/inputTemplate';
import { TemplateProps } from '../common';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { FormError } from 'views/mutual/formErrorScroll';

export type TransactionPurposeProps = {
  formik: any;
  leaseFundPurposeProps: any,
  domesticRealEstatePurposeProps : any,
  overseasRealEstatePurposeProps : any,
  isAnyPurposeSelectedProps : any,
};

export const TransactionPurposeWrapper = () => {
  return <TransactionPurpose {...useTransactionPurpose({ isUpdate: false })} />;
};

export const TransactionPurpose = ({ formik, leaseFundPurposeProps, domesticRealEstatePurposeProps, overseasRealEstatePurposeProps, isAnyPurposeSelectedProps, isUpdate }: TransactionPurposeProps & TemplateProps) => {
  const { setAccountOpenProfileDetailsPageType } = useCorporateAccountOpenProfileDetailsPageTypeStore();

  useCustomLocationName('口座開設申込みフォーム');

  return (
    <form onSubmit={formik.handleSubmit} className="accountOpenTemplate">
      {!isUpdate && <Caption label="取引目的" />}
      <div className="accountOpenTemplate_input">
        <FormContentHeader label="今後お取引を希望される商品についてご回答ください" formType={FormType.Required} />
        <div className='accountOpenTemplate_input_error'>
          <FormError className="inputTemplate_error" error={isAnyPurposeSelectedProps.error} />
        </div>
        <div className="accountOpenTemplate_input_wrapper">
          <div className='accountOpenTemplate_checkBoxHeader'>
            <CheckInput
            {...isAnyPurposeSelectedProps.leaseFund}
            label={<FormContentHeader label="日本型オペレーティング・リース案件" />}
            />
            <>{isAnyPurposeSelectedProps.leaseFund.checked}</>
            {isAnyPurposeSelectedProps.leaseFund.checked &&(
              <div className="accountOpenTemplate_checkBoxHeader_check">
                <MultiCheckInput {...leaseFundPurposeProps.multiCheckInput} />
                {leaseFundPurposeProps.otherText && (
                  <InputTemplate
                    placeholder="その他を選択された場合は内容を具体的にご記入ください"
                    {...leaseFundPurposeProps.otherText}
                  />
                )}
              </div>
            )}
          </div>

          <div className='accountOpenTemplate_checkBoxHeader'>
            <CheckInput
            {...isAnyPurposeSelectedProps.domesticRealEstate}
            label={<FormContentHeader label="不動産小口化商品"/>}
            />
          </div>
          {isAnyPurposeSelectedProps.domesticRealEstate.checked && (
            <div className="accountOpenTemplate_checkBoxHeader_check">
              <MultiCheckInput {...domesticRealEstatePurposeProps.multiCheckInput} />
              {domesticRealEstatePurposeProps.otherText && (
                <InputTemplate
                  placeholder="その他を選択された場合は内容を具体的にご記入ください"
                  {...domesticRealEstatePurposeProps.otherText}
                />
              )}
            </div>
          )}
          <div className='accountOpenTemplate_checkBoxHeader'>
            <CheckInput
            {...isAnyPurposeSelectedProps.overseasRealEstate}
            label={<FormContentHeader label="海外不動産案件" />}
            />
          </div>
          {isAnyPurposeSelectedProps.overseasRealEstate.checked &&(
            <div className="accountOpenTemplate_checkBoxHeader_check">
            <MultiCheckInput {...overseasRealEstatePurposeProps.multiCheckInput} />
            {overseasRealEstatePurposeProps.otherText && (
              <InputTemplate
                placeholder="その他を選択された場合は内容を具体的にご記入ください"
                {...overseasRealEstatePurposeProps.otherText}
              />
            )}
          </div>
          )}
        </div>
      </div>
      {!isUpdate && (
        <div className="accountOpenTemplate_button">
          <Button type={ButtonType.Submit} label="次へ" buttonFill={ButtonFill.black} buttonSize={ButtonSize.medium} />
          <Button
            label="前の画面に戻る"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.small}
            onClick={() => setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.corporateInfo)}
          />
        </div>
      )}
    </form>
  );
};
